import React from "react";
import { Routes, Route } from "react-router-dom";
import App from "../App";
import Privacy from "../pages/Privacy/Privacy";
import Support from "../pages/Support/Support";
import Delete from "../pages/Delete/Delete";
import Memory from "../pages/Memory/Memory";
import LiveKit from "../pages/LiveKit/LiveKit";
import LiveKitMemory from "../pages/LiveKitMemory/LiveKitMemory";
import PriorityCustomers from "../pages/PriorityCustomers/PriorityCustomers";
import BasilWoods from "../pages/BasilWoods/BasilWoods";
import HomeDemo from "../pages/HomeDemo/HomeDemo";
import RainbowPoc from "../pages/RainbowPoc/RainbowPoc";

function Router() {
  return (
    <Routes>
      <Route path="/" element={<LiveKitMemory />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/support" element={<Support />} />
      <Route path="/account/confirm-deletion" element={<Delete />} />
      <Route path="/beta" element={<Memory />} />
      {/* <Route path="/livekit" element={<LiveKit />} /> */}
      <Route path="/livekit" element={<LiveKitMemory />} />
      <Route path="/priority-customers" element={<PriorityCustomers />} />
      <Route path="/basil-woods" element={<BasilWoods />} />
      <Route path="/home-demo" element={<HomeDemo />} />
      <Route path="/rainbow-poc" element={<RainbowPoc />} />
    </Routes>
  );
}

export default Router;
